<taku-adyen-integration
  [adyenOptionOverrides]="{ showPayButton: true, payButtonTitle: 'Save Card' }"
  [customerAccountData]="account"
  (adyenFormSubmit)="submit($event)"
></taku-adyen-integration>
